import { toast as sonnerToast } from 'vue-sonner';
import ErrorToast from 'dashboard/components-next/toast/ErrorToast.vue';

// Error toasts must stay longer on screen and offer a one-click way to copy
// the error message to the clipboard. We render a custom component so the copy
// affordance is a discreet icon-button with tooltip instead of the bulky text
// action button. Everything else (success, promise, loading, warning, info,
// dismiss, etc.) is delegated untouched to vue-sonner.
const DEFAULT_ERROR_DURATION = 10000;

// vue-sonner 2.0.9 does NOT inject the toast id into custom components, so we
// mint a stable id here and hand it both to sonner (`id`) and the component
// (`componentProps.toastId`) so the X button can call `toast.dismiss(id)`.
let errorSeq = 0;

function error(message, opts = {}) {
  const id = opts.id ?? `err_${(errorSeq += 1)}`;
  return sonnerToast.custom(ErrorToast, {
    id,
    duration: DEFAULT_ERROR_DURATION,
    ...opts,
    componentProps: { message: String(message), toastId: id },
  });
}

// `toast` is callable (`toast(...)`) and exposes methods. Keep it callable by
// wrapping the base function, copy every method/property from sonner, then
// override `error`.
const toast = (...args) => sonnerToast(...args);
Object.assign(toast, sonnerToast, { error });

export { toast };
export default toast;
